import {
  IconBrand,
  IconProtocol,
  IconClient,
  IconCaller,
  IconResponder,
  IconPlatform,
  IconSelfhost,
} from "@/app/components/icons";
import {
  productIcons,
  brandIconSizes,
  type ProductIconEntry,
} from "@/design-system/registry/playground-icons";

const iconComponentMap = {
  Protocol: IconProtocol,
  Client: IconClient,
  Caller: IconCaller,
  Responder: IconResponder,
  Platform: IconPlatform,
  Selfhost: IconSelfhost,
} as const;

function ProductIconCard({ entry }: { entry: ProductIconEntry }) {
  const Icon = iconComponentMap[entry.iconKey];
  return (
    <div className="flex items-center gap-4 border-4 border-black p-4 bg-zinc-50 shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] transition-all cursor-pointer">
      <Icon className="w-16 h-16 flex-shrink-0" />
      <div>
        <div className={`font-black uppercase tracking-widest ${entry.colorClass} text-stroke-black`}>{entry.name}</div>
        <div className="text-xs font-bold text-zinc-600">{entry.subtitle}</div>
      </div>
    </div>
  );
}

export function PlaygroundIconsSection() {
  return (
    <div className="space-y-16 mt-8">
      <div className="space-y-6">
        <h3 className="text-xl font-bold font-mono border-b-4 border-black pb-2">【F.1】 Primary Brand Icon</h3>
        <p className="text-sm font-medium">满印几何图腾：外框 → 四角对角线 → 内方块 → 内切圆 → X交叉 → CALL / ANYTHING 文字。品牌绿底 + 黑线。</p>

        {/* Brand wordmark — Light & Dark */}
        <div className="flex flex-wrap gap-4">
          <div className="border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] bg-zinc-50 p-6 inline-flex items-center gap-5">
            <IconBrand className="w-12 h-12 border-4 border-black flex-shrink-0" />
            <div className="flex flex-col items-start gap-1.5">
              <p className="text-3xl font-black uppercase tracking-tight text-black leading-none">CALL ANYTHING</p>
              <p className="bg-[#A3E635] px-1.5 py-0.5 text-xs font-black tracking-widest text-black leading-none transition-all duration-300 hover:bg-[#8B5CF6] hover:text-white hover:-translate-y-0.5 hover:rotate-3 hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] cursor-pointer">
                一呼百应
              </p>
            </div>
          </div>

          <div className="border-4 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] bg-black p-6 inline-flex items-center gap-5">
            <IconBrand className="w-12 h-12 border-4 border-black flex-shrink-0" />
            <div className="flex flex-col items-start gap-1.5">
              <p className="text-3xl font-black uppercase tracking-tight text-white leading-none">CALL ANYTHING</p>
              <p className="bg-[#A3E635] px-1.5 py-0.5 text-xs font-black tracking-widest text-black border-2 border-black leading-none transition-all duration-300 hover:bg-[#8B5CF6] hover:text-white hover:-translate-y-0.5 hover:rotate-3 hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] cursor-pointer">
                一呼百应
              </p>
            </div>
          </div>
        </div>

        <div className="flex gap-12 items-end">
          {brandIconSizes.map((s) => (
            <div key={s.label} className="space-y-2">
              <IconBrand className={`${s.size} ${s.border}`} />
              <p className="text-xs text-center font-mono text-zinc-500">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="space-y-6">
        <h3 className="text-xl font-bold font-mono border-b-4 border-black pb-2">【F.2】 Product Layer Icons</h3>
        <p className="text-sm font-medium">
          通用平面图标，每个产品层用各自品牌色底 + 黑色线条图形展现功能定位。Protocol 使用插头图形（与首页 ARCHITECTURE / PROTOCOL 柱一致）。
        </p>
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-8">
          {productIcons.map((entry) => (
            <ProductIconCard key={entry.iconKey} entry={entry} />
          ))}
        </div>
      </div>
    </div>
  );
}
